var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 8.19001C21.32 8.00001 20.98 7.95001 20.68 8.05001L12 10.95L3.32 8.05001C3.01 7.95001 2.68 8.00001 2.42 8.19001C2.15 8.38001 2 8.68001 2 9.00001V19C2 19.43 2.28 19.81 2.68 19.95L11.68 22.95C11.79 22.98 11.89 23 12 23C12.11 23 12.21 22.98 12.31 22.95L21.31 19.95C21.72 19.81 22 19.43 22 19V9.00001C22 8.68001 21.85 8.38001 21.58 8.19001ZM4 10.39L11 12.72V20.61L4 18.28V10.39ZM20 18.28L13 20.61V12.72L20 10.39V18.28Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12.55 7 13 6.55 13 6V2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V6C11 6.55 11.45 7 12 7Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.99998C15.26 8.99998 15.51 8.89998 15.71 8.70998L18.54 5.87998C18.74 5.67998 18.83 5.42998 18.83 5.16998C18.83 4.90998 18.73 4.65998 18.54 4.45998C18.15 4.06998 17.52 4.06998 17.13 4.45998L14.3 7.28998C14.1 7.48998 14 7.73998 14 7.99998C14 8.25998 14.1 8.50998 14.29 8.70998C14.49 8.89998 14.74 8.99998 15 8.99998Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28999 8.70998C8.48999 8.89998 8.73999 8.99998 8.99999 8.99998C9.25999 8.99998 9.50999 8.89998 9.70999 8.70998C9.90999 8.51998 9.99999 8.25998 9.99999 7.99998C9.99999 7.73998 9.89999 7.48998 9.70999 7.28998L6.87999 4.45998C6.48999 4.06998 5.85999 4.06998 5.46999 4.45998C5.26999 4.65998 5.17999 4.90998 5.17999 5.16998C5.17999 5.42998 5.27999 5.67998 5.46999 5.87998L8.28999 8.70998Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/Learn.4c4a082296fa49491a2b9e9011e7a5a1.svg";
export { ForwardRef as ReactComponent };